import React, { type ReactNode } from 'react';
import { useTheme } from '@emotion/react';
import styled from 'types/theme.types';
import envZeroFullBlack from 'assets/images/env-zero-full-black.svg';
import envZeroFullWhite from 'assets/images/env-zero-full-white.svg';

export interface InvitationLayoutProps {
  children?: ReactNode;
}

// The wordmark is a file swap rather than a recolour, and the black/white pair swaps by colour mode
// exactly like topbar-view.tsx's Sign pair - the Logo page ships one mark per background.
const InvitationLayout: React.FunctionComponent<InvitationLayoutProps> = ({ children }) => {
  const theme = useTheme();

  return (
    <Container>
      <LogoContainer>
        <img width="180px" src={theme.mode === 'dark' ? envZeroFullWhite : envZeroFullBlack} alt="env zero" />
      </LogoContainer>
      {children}
    </Container>
  );
};

const Container = styled.div`
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: hidden;

  background-color: var(--surface-main-page);

  display: flex;
  align-items: center;
  justify-content: center;
`;

// Centred with a transform so the asset's own width is not a magic number.
const LogoContainer = styled.div`
  position: absolute;
  top: 80px;

  left: 50%;
  transform: translateX(-50%);
`;

export default InvitationLayout;
